import React from "react";

const PaymentsRiders = () => {
  return <div>PaymentsRiders</div>;
};

export default PaymentsRiders;
